import { render } from "./SellerTerms.vue?vue&type=template&id=7c016de2&scoped=true"
const script = {}

import "./SellerTerms.vue?vue&type=style&index=0&id=7c016de2&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c016de2"]])

export default __exports__